export class JobDTO {
  name?: string;
  companyName?: string;
  externalUrl?: string;
  createdAt?: string;
  description?: string;
  recruiterName?: string;
  shortLocation?: string;
  sourceName?: string;
  providerId?: string;

  constructor(data: any) {
    Object.assign(this, data);
  }

  getAddressPreview() {

    const splitted = this.shortLocation.split('|');
    return splitted?.length > 1 ? `${splitted[0]} +${splitted.length} città` : this.shortLocation;
  }

  getCities() {
    return this.shortLocation.split('|')?.sort();
  }

}
